import { ChangeDetectionStrategy, Component, ElementRef, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mcrai-dd',
  template: `<ng-content></ng-content>
`,
  styles: [`.mcrai-dd{display:block;margin-bottom:10px}`],
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DescListDataComponent implements OnInit {
  readonly DESC_LIST_DATA_CLASS = 'mcrai-dd';

  constructor(
    private _renderer: Renderer2,
    private _elRef: ElementRef
  ) { }

  ngOnInit() {
    this._renderer
      .addClass(this._elRef.nativeElement, this.DESC_LIST_DATA_CLASS);
  }
}
